module.exports = __webpack_public_path__ + "img/0.101136cb.png";